import React, { Component } from "react";
import { Card, FormGroup, Label, FormFeedback, Input } from "reactstrap";
import { connect } from "react-redux";

import { LARGE_DEVICE_MIN_WIDTH } from "../../util.js";
import {
  NEW_COMMENT_TEXT_CHANGED,
  NEW_COMMENT_REQUESTED
} from "../../actions.js";

class NewCommentCard extends Component {
  render() {
    const text = this.props.newCommentText;

    const error = text.length > 140;
    const disabled = text.length === 0 || error;
    const classes = error ? "form-control is-invalid" : "form-control is-valid";
    return (
      <Card className="new-comment-card padded">
        <form
          onSubmit={event =>
            this.props.onSubmit(
              event,
              this.props.professor.id,
              this.textArea.value
            )
          }
        >
          <FormGroup>
            <Label for="newComment">
              ¡Deja un ProfeComment! Son totalmente anónimos.
            </Label>
            <textarea
              autoFocus={window.innerWidth > LARGE_DEVICE_MIN_WIDTH}
              ref={r => (this.textArea = r)}
              className={classes}
              name="text"
              id="newComment"
              onChange={event => this.props.onChange(event.target.value)}
              value={this.props.newCommentText}
            />
            {error && (
              <FormFeedback>
                ¡ProfeComments tienen que ser menos de 140 letras!
              </FormFeedback>
            )}
          </FormGroup>
          <Input type="submit" disabled={disabled} />
        </form>
      </Card>
    );
  }
}

export const BAD_COMMENT_SUBMITTED = "BAD_COMMENT_SUBMITTED";

const mapStateToProps = state => state;

const mapDispatchToProps = dispatch => {
  return {
    onChange: value => {
      dispatch({ type: NEW_COMMENT_TEXT_CHANGED, value });
    },
    onSubmit: (event, professorId, text) => {
      event.preventDefault();
      dispatch({ type: NEW_COMMENT_REQUESTED, professorId, text });
    }
  };
};

const NewCommentContainer = connect(mapStateToProps, mapDispatchToProps)(
  NewCommentCard
);

export default NewCommentContainer;



// WEBPACK FOOTER //
// ./src/containers/profecomments/NewCommentContainer.js